module.exports = __webpack_public_path__ + "media/images/city_img/s_4-d9572dc1ad2006668c5a1d2cc33e9921.png";